// extracted by mini-css-extract-plugin
export default {"Container":"TeamSlots_Container__XGfJq"};